import { Pipe, PipeTransform } from '@angular/core';
import { FacilityTypes } from 'src/app/feature/site-rediness-matrix/constants/enums';

@Pipe({
  name: 'facilityType'
})

export class FacilityTypePipe implements PipeTransform {
  transform(value: string, ...args: any[]): string {
    if (value === 'MD') {
      return FacilityTypes.MD;
    } else {
      return FacilityTypes.CRM;
    }
  }
}
